import lessRequire from '../../../../config/less-require-resolver';
import React, { Component } from 'react';
import axios from 'axios';
import qs from 'qs';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import switchStatsLinkConfig from '../../shared/switch-cfg';
import { selectors } from '../../ban';

import { getDateRangeFromCalendar } from '../../shared/utils';

import { baseUrl } from '../../../../config/route-entry-point';
import endpoints from '../../../../config/endpoints';

lessRequire('modules/shared/switch.less');
lessRequire('modules/statistics/components/switch/main.less');

class Switch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			unacceptableConversionsCount: null
		};
	}

	componentDidMount() {
		const { calendar } = this.props;
		axios.get(`${endpoints.STATISTICS.UNACCEPTABLE_CONVERSIONS}/count?${qs.stringify({
			date_range: getDateRangeFromCalendar(calendar)
		})}`)
			.then(data => this.setState({
				unacceptableConversionsCount: Number(data.data.unacceptable_conversions_count) || null
			}));
	}

	render() {
		const { onSwitch, intl, isShowedAutoTrash, activeTab } = this.props;
		const links = switchStatsLinkConfig.filter(cfg => !cfg.isVisibleWithFlag || isShowedAutoTrash);
		return (
			<div className="header-switch stats-switch">
				<div className="header-switch__links font-proxima-nova-semibold">
					{ links.map((link, i) => (
						<Link key={i}
							to={baseUrl(link.url)}
							className={`${link.className} stats-switch-link`}
							activeClassName="active"
							onClick={onSwitch ? e => onSwitch(link.url) : null}
						>
							{ intl(link.title) }
							{
								link.isAddedAutoTrashNumber &&
								this.state.unacceptableConversionsCount &&
								activeTab !== 'autotrash' &&
								<span className="unseen-autotrash-count">{this.state.unacceptableConversionsCount}</span>
							}
						</Link>
					)) }
				</div>
			</div>
		);
	}
}

export default connect(state => ({
	calendar: state.unacceptableConversions.calendar,
	isShowedAutoTrash: selectors.getIsShowedAutoTrash(state)
}))(Switch);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/switch/main.js